import React from 'react';
import {NavLink} from "react-router-dom";
import { RiUserSettingsLine} from "react-icons/ri";

import {PiChatTeardropText, PiPhone} from "react-icons/pi";

import {TbSmartHome} from "react-icons/tb";
import {LiaUserSolid} from "react-icons/lia";
import {ImSearch} from "react-icons/im";



const Navbar = (props) => {


    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-white nav-bar-app mobile-size-option ">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><TbSmartHome className='nav-icon'/></div>
                    <span>خانه</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/factors">
                    <div><PiChatTeardropText  className='nav-icon' /></div>
                    <span >پیش‌فاکتور</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/categories">
                    <div><ImSearch className='nav-icon'/></div>
                    <span>محصولات</span>
                </NavLink>
                <NavLink className="nav-item nav-link d-none d-md-block " to="/search">
                    <div><RiUserSettingsLine className='nav-icon'/></div>
                    <span>جستجو</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/calls">
                    <div><PiPhone className='nav-icon'/></div>
                    <span>تماس ها</span>
                </NavLink>

                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><LiaUserSolid className='nav-icon'/></div>
                    <span>  پروفایل</span>
                </NavLink>



            </nav>

        </React.Fragment>
    );
};

export default Navbar;
